import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const AdminContentEngine = lazy(() => import("@/pages/admin/AdminContentEngine"));

export const Route = createFileRoute("/admin/content-engine")({
  component: AdminContentEngine,
});
